var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.FCLSailingScheduleManagement"),
        width: "350px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "shipping-schedule-form-dialog details-view"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-left": "10px" } },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c("el-button", { on: { click: _vm.onCancel } }, [
              _vm._v(_vm._s(_vm.$t("Pricing.Cancel")))
            ])
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content", margin: "10px" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        ref: "pol",
                        attrs: { check: "", label: _vm.$t("Pricing.POL") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            filterable: "",
                            "show-custom-label-in-option": true,
                            "default-value": _vm.ss.pol
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.ss.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pod",
                        attrs: { check: "", label: _vm.$t("Pricing.POD") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            filterable: "",
                            "show-custom-label-in-option": true,
                            "default-value": _vm.ss.pod
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.ss.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "transferPort",
                        attrs: { label: _vm.$t("Pricing.TransferPort") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "transferPort",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            filterable: "",
                            "show-custom-label-in-option": true,
                            "default-value": _vm.ss.transferPort
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.ss.transferPort = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "dockland",
                        attrs: { check: "", label: _vm.$t("Pricing.Dockland") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "dockland" },
                          model: {
                            value: _vm.ss.dockland,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "dockland", $$v)
                            },
                            expression: "ss.dockland"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "carrier",
                        attrs: { check: "", label: _vm.$t("Pricing.Carrier") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true },
                            "custom-label": function(item) {
                              return item.cmpIdx > 0
                                ? "[" + item.shortName + "]" + item.chineseName
                                : ""
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.ss.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.ss.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "lane",
                        attrs: { check: "", label: _vm.$t("Pricing.Lane") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "lane", maxlength: 64 },
                          model: {
                            value: _vm.ss.lane,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "lane", $$v)
                            },
                            expression: "ss.lane"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "closingDay",
                        attrs: {
                          check: "",
                          label: _vm.$t("Pricing.ClosingDay")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "closingDay",
                            disabled: true,
                            value: _vm.ss.closingDay
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "form-flex" },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { no: "closingDay" },
                            model: {
                              value: _vm.closingDay,
                              callback: function($$v) {
                                _vm.closingDay = $$v
                              },
                              expression: "closingDay"
                            }
                          },
                          _vm._l(_vm.frequencys, function(code) {
                            return _c(
                              "el-col",
                              { key: code, staticStyle: { width: "14%" } },
                              [_c("el-checkbox", { attrs: { label: code } })],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "departureDay",
                        attrs: {
                          check: "",
                          label: _vm.$t("Pricing.DepartureDay")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "departureDay",
                            disabled: true,
                            value: _vm.ss.departureDay
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "form-flex" },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { no: "departure" },
                            model: {
                              value: _vm.departure,
                              callback: function($$v) {
                                _vm.departure = $$v
                              },
                              expression: "departure"
                            }
                          },
                          _vm._l(_vm.frequencys, function(code) {
                            return _c(
                              "el-col",
                              { key: code, staticStyle: { width: "14%" } },
                              [_c("el-checkbox", { attrs: { label: code } })],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DaysUnitSea") } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "days",
                            min: 0,
                            value: _vm.ss.days,
                            "controls-position": "right",
                            max: 999999999
                          },
                          model: {
                            value: _vm.ss.days,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "days", $$v)
                            },
                            expression: "ss.days"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: { check: "", label: _vm.$t("Pricing.BeginDate") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.ss.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.ss, "beginDate", $$v)
                                },
                                expression: "ss.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: { check: "", label: _vm.$t("Pricing.EndDate") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.ss.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.ss, "endDate", $$v)
                                },
                                expression: "ss.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "remarks",
                        attrs: { check: "", label: _vm.$t("Pricing.Remarks") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "remarks",
                            type: "textarea",
                            maxlength: 255
                          },
                          model: {
                            value: _vm.ss.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "remarks", $$v)
                            },
                            expression: "ss.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }